// extracted by mini-css-extract-plugin
export default {"columns":"lsf-columns","columns__title":"lsf-columns__title"};